// Evidon cookie consent menu link handler
document.querySelectorAll('.evidon-consent-menu-link').forEach((el) => {
	el.addEventListener('click', (e) => {
		e.preventDefault();

		const internalButton = document.getElementById('_evh-link');
		if (internalButton) {
			internalButton.click();
		}
	});
});
